import React from "react";
import { WORKFLOW_CODE } from "../../../../workflow/constants/workflow";
import QuoteData from "../../../components/quote-data/QuoteData";
import WorkflowSection from "../../../components/workflow-section/WorkflowSection";
import { Slug } from "../../../types/Navigation";

const Quote: React.FunctionComponent = () => {
  return (
    <>
      <QuoteData />
      <WorkflowSection
        activeStep={Slug.QUOTE}
        code={WORKFLOW_CODE.CREDIT_WORKFLOW}
      />
    </>
  );
};

export default Quote;
